Vue.component('ack-terms-of-service', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-terms-of-service',
    created() {
      
    },
    mounted() {
      appLog.log('ack-terms-of-service mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'terms-of-service-page',
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])




    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })